// Codex-internal debug logger — no app imports allowed
// A lightweight inline version so codex doesn't depend on the app's utils.

/* eslint-disable no-console */
interface DebugLogger {
  info: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
  log: (...args: unknown[]) => void;
}

export function createDebugLogger(prefix: string): DebugLogger {
  return {
    info: (...args) => console.log(`[${prefix}]`, ...args),
    warn: (...args) => console.warn(`[${prefix}]`, ...args),
    error: (...args) => console.error(`[${prefix}]`, ...args),
    log: (...args) => console.log(`[${prefix}]`, ...args),
  };
}

export function useDebugLogger(prefix: string): DebugLogger {
  return createDebugLogger(prefix);
}

export default useDebugLogger;
/* eslint-enable no-console */
